import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './styles.module.scss'
import Strikethrough from '../CartItem/Strikethrough'
import StrikethroughVariant from '../CartItem/Strikethrough/StrikethroughVariant'
import { Accordion } from '@saatva-bits/pattern-library.components.accordion'
import { useExperiment } from '@saatva-bits/pattern-library.modules.launch-darkly'

const BundleGroup = ({children, label = '', bundledItems = [], sitewidePromo}) => {
    const { isV1: PERCENT_OFF_STRIKETHROUGH_ON } = useExperiment('EXP.PERCENT_OFF_CART.CONV-321')
    const [isOpen, setIsOpen] = useState(true)
    
    const title = (
        <div className={styles.title}>
            <div className={styles.titleLabelContainer}>{label}&nbsp;{bundledItems.length ? `(${bundledItems.length} items)` : ''}</div>
            {!isOpen && (
                PERCENT_OFF_STRIKETHROUGH_ON
                    ? <StrikethroughVariant item={bundledItems} sitewidePromo={sitewidePromo} dataSelector='cartBundleItem' priceContainerClassName={styles.priceContainer} />
                    : <Strikethrough item={bundledItems} sitewidePromo={sitewidePromo} dataSelector='cartBundleItem' priceContainerClassName={styles.priceContainer} />
            )}
        </div>
    )

    return (
        <Accordion
            title={title}
            titleContainerClassName={classNames(styles.titleContainer, {
                [styles.titleContainerClosed]: !isOpen
            })}
            titleInnerContainerClassName={styles.titleInnerContainer}
            contentClassName={classNames(styles.contentContainer, { isOpen })}
            contentContainerClassName={styles.content}
            iconContainerClassName={styles.iconContainer}
            iconClassName={classNames(styles.icon, { isOpen })}
            isOpenOnRender={true}
            collapseIconName = 'arrow-down'
            expandIconName = 'arrow-down'
            onAccordionItemClick={() => {setIsOpen((prevIsOpen) => !prevIsOpen)}}
            titleLabel= 'bundle-group-title'
            contentLabel= 'bundle-group-content'
            dataSelector='bundle-group'

        >
            {children}
        </Accordion>
    )
}

BundleGroup.propTypes = {
    children: PropTypes.node,
    bundledItems: PropTypes.array.isRequired,
    sitewidePromo: PropTypes.object.isRequired,
    label: PropTypes.string
}

export default BundleGroup
